import styled from "styled-components";

export const SignatureItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #aaaaaa;
  padding-top: 6px;
  padding-bottom: 6px;
`;

export const SignatureMemberDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SignatureMemberIndex = styled.span`
    font-size: 14px;
    color: #000000;
    font: "Inter",
    font-weight: 400;
    line-height: 20px;
`;

export const SignatureMemberInfo = styled.div`
    display: flex;
    flex-direction: column;
`

export const SignatureMemberName = styled.span`
    font-size: 14px;
    color: #000000;
    font: "Inter";
    font-weight: 700;
    line-height: 20px;
`

export const SignatureMemberEmail = styled.span`
    font-size: 14px;
    color: #000000;
    font: "Inter",
    font-weight: 400;
    line-height: 20px;
`

export const SignatureStatusDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const SignatureStatus = styled.span`
    justify-content: left;
    margin-left: 10px;
    font-size: 12px;
    color: #000000;
    font: "Inter";
    font-weight: 700;
    line-height: 20px;
`

export const SignatureDate = styled.span`
    font-size: 14px;
    color: #000000;
    font: "Inter";
    font-weight: 400;
    line-height: 20px;
`
